import React from 'react';
import { ConfigurableLink } from 'swag-client-common/components/utils/configurable-link';
import classnames from 'classnames';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import classes from './swag-logo.scss';
export let Color = /*#__PURE__*/function (Color) {
  Color["white"] = "white";
  Color["black"] = "black";
  Color["blue"] = "blue";
  Color["limitedEdition"] = "limitedEdition";
  return Color;
}({});
export const SwagLogo = ({
  children,
  link = APP_ROUTES.HOME,
  isHardLink,
  routeNavigationConfirmation,
  partners,
  logoLink,
  logoClassName = '',
  containerClassName = '',
  sticky,
  imgAlt = 'Swag'
}) => {
  const {
    pathname
  } = window.location;
  const hideAdditionalLogo = pathname === `${APP_ROUTES.SPRING_PRODUCTS}/all-swag` || pathname === `${APP_ROUTES.TECHSTARS_PRODUCTS}/all-swag`;
  return /*#__PURE__*/React.createElement(ConfigurableLink, {
    isHardLink: isHardLink,
    routeNavigationConfirmation: routeNavigationConfirmation,
    link: link,
    className: classnames(classes.container, containerClassName),
    tabIndex: -1
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.logoContainer
  }, /*#__PURE__*/React.createElement("img", {
    alt: imgAlt,
    className: classnames(classes.logo, logoClassName),
    src: logoLink
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.partners, {
      [classes.hidden]: hideAdditionalLogo,
      [classes.partnersSticky]: sticky
    })
  }, partners)), children);
};